import { render, staticRenderFns } from "./threeOrone.vue?vue&type=template&id=5ed836d6&scoped=true&"
import script from "./threeOrone.vue?vue&type=script&lang=js&"
export * from "./threeOrone.vue?vue&type=script&lang=js&"
import style0 from "./threeOrone.vue?vue&type=style&index=0&id=5ed836d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed836d6",
  null
  
)

export default component.exports